import { defineAction, enumerated, number, object, string } from '~/prix'
import neighborhoodNewShapes from './neighborhoodNewShapes.action.json' with { type: 'json' }

const neighborhoodNewShapesDefinition = defineAction({
  ...neighborhoodNewShapes,
  input: object({
    level: enumerated({
      macroRegion: 'macroRegion',
      mesoRegion: 'mesoRegion',
      microRegion: 'microRegion',
      state: 'state',
      city: 'city',
    }).isOptional(),
    ibgeCodes: string(),
  }),
  output: object({}),
})

export default neighborhoodNewShapesDefinition
